// extracted by mini-css-extract-plugin
export default {"progressBar":"Map-module-progressBar","searchFeedback":"Map-module-searchFeedback"};